import moment from 'moment';

/**
 * Tag disponibili per template: template_ddt_customer
 *
 * TESTATA:
 *   {internalCode}       - Codice interno DDT
 *   {date}               - Data DDT (DD/MM/YYYY)
 *   {customerCode}       - Codice cliente
 *   {vatNumberCustomer}  - P.IVA cliente
 *   {nameCustomer}       - Nome cliente
 *   {addressCustomer}    - Indirizzo cliente
 *   {phoneCustomer}      - Telefono cliente
 *   {destination}        - Destinazione (o "Idem" se uguale)
 *   {paymentCondition}   - Condizione di pagamento
 *   {externalCode}       - Codice esterno
 *
 * RIGHE (loop {#rows}...{/rows}):
 *   {code}      - Codice articolo
 *   {name}      - Descrizione articolo
 *   {um}        - Unita di misura
 *   {quantity}  - Quantita
 *
 * TRASPORTO:
 *   {transportReason}  - Causale trasporto
 *   {weight}           - Peso
 *   {volume}           - Volume
 *   {packagesQuantity} - Numero colli
 *   {transportBy}      - Trasporto a cura di
 *   {itemsAspect}      - Aspetto dei beni
 *   {nameForwarder}    - Nome corriere
 *   {notes}            - Note
 *
 * Extra args: dataOrder (oggetto ordine cliente associato)
 */

function getTransportBy(val) {
    if (!val) return '';
    const v = val.value || val.label || val;
    if (v === '0_SENDER') return 'Mittente';
    if (v === '1_RECIPIENT') return 'Destinatario';
    if (v === '2_CARRIER') return 'Vettore';
    return '';
}

function getItemsAspect(val) {
    if (!val) return '';
    const v = val.value || val.label || val;
    if (v === '0_SCATOLE') return 'Scatole';
    if (v === '5_VISTA') return 'A Vista';
    if (v === '10_PLURIBOL') return 'Pluribol';
    if (v === '15_CARTONI') return 'Cartoni';
    return v;
}

export default {
    tags: {
        internalCode: 'internalCode',
        date: { path: 'date', format: 'date' },
        customerCode: { paths: ['idCustomer.code', 'idCustomer'] },
        vatNumberCustomer: 'vatNumberCustomer',
        nameCustomer: 'nameCustomer',
        addressCustomer: 'addressCustomer',
        paymentCondition: 'paymentConditionCustomer',
        transportReason: { path: 'transportReason', default: 'VENDITA' },
        weight: { path: 'weight', format: 'decimal:3' },
        volume: { path: 'volume', format: 'decimal:3' },
        packagesQuantity: 'packagesQuantity',
        nameForwarder: 'nameForwarder',
        notes: 'notes',
    },

    rows: {
        source: 'rows',
        tags: {
            code: 'codeItemModel',
            name: 'nameItemModel',
            um: { path: 'unitItemModel', default: 'NR' },
            quantity: 'quantity',
        }
    },

    // dataOrder viene passato come extra arg
    computed: (data, dataOrder) => {
        const destination = dataOrder?.address;
        const destinationText = destination
            ? (destination.name || destination.address || '')
            : (data.addressCustomerOffice || '');
        const isDestinationSame = destinationText === data.addressCustomer || !destinationText;

        return {
            phoneCustomer: data.phoneCustomer || dataOrder?.address?.phone || '',
            destination: isDestinationSame ? 'Idem' : destinationText,
            externalCode: dataOrder?.externalCode || data.externalCode || '',
            transportBy: getTransportBy(data.transportBy),
            itemsAspect: getItemsAspect(data.itemsAspect),
        };
    }
};
